import { render } from "./FieldMultipleChoice.vue?vue&type=template&id=cb35363a"
import script from "./FieldMultipleChoice.vue?vue&type=script&lang=js"
export * from "./FieldMultipleChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__